export default __webpack_public_path__ + "static/media/summonauraofnebthu.60686ca1.png";